// extracted by mini-css-extract-plugin
export var header = "_vc-1";
export var maskBottom = "_vc-6";
export var maskMiddle = "_vc-7";
export var maskTop = "_vc-5";
export var root = "_vc-0";
export var scrollDownButton = "_vc-3";
export var scrollDownButtonHidden = "_vc-4";
export var viewport = "_vc-2";